import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { BodyContext } from '~/context/BodyContext.js'
import { Watch, Actions } from '~/scripts'
import J from 'juicy-ui'
import C from '~/components';

export default class Home extends Component {
    static contextType = BodyContext;
    constructor() {
        super()
        this.pageName = 'home'
        this.state = {
            interf: {
            },
            storage: {
            }
        }
    }
    componentWillMount() {
    }
    componentDidMount() {
        Watch.init(this);
    }
    render() {
        const [CT] = this.context;
        const interf = this.state.interf
        return (
            <>
                <C.Catalogue />
            </>
        )
    }
}